import { acConfig } from '@ac/library-utils/dist/declarations';

export const isReservationsGroupsModule = (
  pathname: string = window.location.pathname
): boolean => {
  return pathname?.startsWith(
    acConfig.newFrontendUrls.reservationsGroups ?? ''
  );
};

export default {
  isReservationsGroupsModule,
};
